import { Common } from './common';

export class SupplierWorktimeEventLog extends Common {
    public supplierUserName: string;
}
